<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as MY_EXTERNAL_TASKS_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'
import { axiosThux } from '@/axiosThux'

import MyExternalTasksTable from './MyExternalTasksTable.vue'
import TaskInlineDetail from '@/pages/task/task/TaskInlineDetail.vue'
import TaskCreate from '@/pages/task/task/TaskCreate.vue'
import { ROUTES as ACTIVITY_ROUTES } from '@/pages/activity/router'

export default {
  name: 'MyExternalTasksList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': MyExternalTasksTable,
    'component-detail': TaskInlineDetail,
    'component-edit': TaskCreate
  },
  props: {
    onlyMine: { type: Boolean, default: false }
  },
  data () {
    const searchFields = [
      { key: 'filter__name__icontains', placeholder: this.$t('Activity'), type: 'text', col: 4 },
      { key: 'filter__category', placeholder: this.$t('Category'), type: 'select', options: [], col: 4 },
      { key: 'filter__tags__name__icontains', placeholder: this.$t('Tags'), type: 'text', col: 4 },
      { key: 'filter__organization__name__icontains', placeholder: this.$t('Customer'), type: 'text', col: 4 },
      { key: 'filter__state__code', placeholder: this.$t('State'), type: 'text', col: 4 }
    ]
    if (this.$route && this.$route.name === ACTIVITY_ROUTES.ACTIVITY_PIDUECI) {
      searchFields.push({ key: 'filter__assignees__contact__last_name__icontains', placeholder: this.$t('Assignee last name'), type: 'text', col: 4 })
    }
    searchFields.push(
      { key: 'filter__due_date__gte', placeholder: this.$t('Due date from'), type: 'date', col: 4 },
      { key: 'filter__due_date__lte', placeholder: this.$t('Due date to'), type: 'date', col: 4 }
    )
    return {
      title: this.$t('External activities'),
      fieldName: 'id',
      searchFields: searchFields,
      showCommonFilters: false,
      showAdvancedSearch: false,
      toggleAdvancedSearch: true,
      showHeader: false,
      rolePerm: 'tasks_task_my_external',
      editParams: { categoryTypeCode: 'customer', onSaved: () => this.getList() }
    }
  },
  computed: {
    ...mapGetters({
      ...MY_EXTERNAL_TASKS_TYPES.GENERIC.dashboard.myexternaltasks.LIST.GETTERS
    }),
    canAddInstance () {
      return hasPerm('tasks_task_create')
    },
    canSeeActionSelect () {
      return false
    }
  },
  watch: {
    onlyMine: {
      immediate: true,
      handler (val) {
        this.setOnlyMine(val)
        this.$set(this, 'tableParams', { readOnly: !!val })
        this.$set(this, 'detailParams', { readOnly: false, categoryTypeCode: 'customer', onSaved: () => this.getList() })
      }
    }
  },
  created () {
    this.loadCategoryOptions()
  },
  methods: {
    loadCategoryOptions () {
      const profile = this.$store.getters['auth/profile'] || 'generic'
      axiosThux.get(`/api/v1/task/${profile}/task-category/?filter__status=1&filter__type__code=customer&page_size=1000`)
        .then((resp) => {
          const results = (resp.data && resp.data.results) || []
          const options = results.map((c) => ({ value: c.id, text: c.name }))
          options.unshift({ value: null, text: '' })
          const idx = this.searchFields.findIndex((f) => f.key === 'filter__category')
          if (idx !== -1) this.$set(this.searchFields[idx], 'options', options)
        })
        .catch(() => {})
    },
    ...mapMutations({
      setOrderBy: MY_EXTERNAL_TASKS_TYPES.GENERIC.dashboard.myexternaltasks.LIST.MUTATIONS.setOrderBy
    }),
    ...mapActions({
      ...MY_EXTERNAL_TASKS_TYPES.GENERIC.dashboard.myexternaltasks.LIST.ACTIONS,
      setOnlyMine: MY_EXTERNAL_TASKS_TYPES.GENERIC.dashboard.myexternaltasks.LIST.ACTIONS.setOnlyMine
    }),
    currentUserAssignees () {
      if (!this.onlyMine) return null
      const me = this.$store.getters['auth/me']
      if (!me || me.id == null) return null
      const fullName = `${me.first_name || ''} ${me.last_name || ''}`.trim() || me.email || `#${me.id}`
      return [{ id: me.id, full_name: fullName }]
    },
    openEditForm (id) {
      this.$set(this, 'editParams', {
        categoryTypeCode: 'customer',
        onSaved: () => this.getList(),
        defaultAssignees: this.currentUserAssignees()
      })
      this.$set(this, 'componentId', id)
      this.$set(this, 'showEditForm', true)
      this.$set(this, 'showDetailForm', false)
      this.$emit('form-opened')
    },
    closeForms () {
      this.$set(this, 'showEditForm', false)
      this.$set(this, 'showDetailForm', false)
    },
    openDetailForm (payload, isSubtaskCreation) {
      if (isSubtaskCreation && payload && typeof payload === 'object') {
        this.$set(this, 'detailParams', {
          isSubtaskCreation: true,
          item: payload,
          categoryTypeCode: 'customer',
          onSaved: () => this.getList(),
          defaultAssignees: this.currentUserAssignees()
        })
        this.$set(this, 'componentId', null)
      } else {
        this.$set(this, 'detailParams', { readOnly: false, categoryTypeCode: 'customer', onSaved: () => this.getList() })
        this.$set(this, 'componentId', payload)
      }
      this.$set(this, 'showDetailForm', true)
      this.$set(this, 'showEditForm', false)
      this.$emit('form-opened')
    },
    closeDetailForm () {
      this.$set(this, 'showDetailForm', false)
      this.getList()
    }
  }
}
</script>
